import { flatMap, isFunction, map } from 'lodash'
import { inEnum, isNonEmptyArray } from '.'

/** @enum {string} */
export const Actions = Object.freeze({
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  RELOAD: 'RELOAD'
})

/** @enum {string} */
export const Events = Object.freeze({
  CLICK: 'CLICK',
  DOUBLE_CLICK: 'DOUBLE_CLICK',
  DRAG_STOP: 'DRAG_STOP',
  STRICT_VERTICAL_DRAG_STOP: 'STRICT_VERTICAL_DRAG_STOP',
  LONG_CLICK: 'LONG_CLICK',
  CLICK_COLDOWN: 'CLICK_COLDOWN',
  DELETE_PRESSED: 'DELETE_PRESSED',
  ESCAPE_PRESSED: 'ESCAPE_PRESSED',
  CONTROL_CLICK: 'CONTROL_CLICK'
})

export const toItemActionPairs = (items, action, flatten = true) => {
  action = inEnum(Actions, action) ? action : null
  const format = flatten ? flatMap : map

  return isNonEmptyArray(items) ? format(items, item => [item, action]) : [items, action]
}

export const deleteData = (data, apiCall, syncAction) => {
  if (isNonEmptyArray(data) || data.id > 0) {
    apiCall(data)
  }

  if (isFunction(syncAction)) {
    syncAction(...toItemActionPairs(data, Actions.DELETE))
  }
}

export const dataUpsert = (data, oldData, apiCall, equivalenceComparator, syncAction) => {
  if ((!isFunction(equivalenceComparator) || isFunction(equivalenceComparator)) && !equivalenceComparator(data, oldData)) {
    if (isFunction(syncAction)) {
      syncAction(...toItemActionPairs(data, Actions.UPDATE))
    }

    apiCall(data, oldData)
  }
}

export const newSelection = (selection = [], selectedItem = null, event) => {
  let newSelection = []

  if (selectedItem !== null && selectedItem.data !== null && selectedItem.id !== -1) {
    if ((event === Events.DRAG_STOP || event === Events.CLICK) && (!selection.some(item => item.id === selectedItem.id) || selection.length > 1)) {
      newSelection = [selectedItem]
    } else if (event === Events.CONTROL_CLICK) {
      if (selection.some(item => item.id === selectedItem.id)) {
        newSelection = selection.filter(item => item.id !== selectedItem.id)
      } else {
        newSelection = selection.concat(selectedItem)
      }
    }
  }

  return newSelection
}
